/* eslint-disable no-undef */
/****************************************************************************
 * Copyright 2018 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

// import {h, Component } from 'preact';
import React from 'react'
import { connect } from 'react-redux'
import { updateBaseInfo } from '../../state/toolbar'
import Dialog from '../../component/dialog'
import { initClipboard } from '../../state/hotkeys'
// import { onAction, load } from '../../state/shared';
import { request } from '../../../api'

class IupacDialog extends React.PureComponent {
  onOkClick = () => {
    this.sendIUPAC()
  }
  onOCRClick = () => {
    this.postMessage('iupacOCRClick')
  }
  postMessage = (type, val = {}) => {
    window.parent.postMessage(
      {
        type,
        val
      },
      '*'
    )
  }
  sendIUPAC = async () => {
    const { iupacText } = this.props
    if (iupacText.trim().length === 0) return alert('IUPAC Name不能为空')
    this.postMessage('setLoading', true)
    const res = await request(
      'POST',
      `${ketcher.api_path_stone}/task/molecule/smiles/convert`,
      {
        iupac: iupacText.trim()
      }
    )
    this.postMessage('setLoading', false)
    if (res.code === 200 && res.data.mol) {
      setTimeout(() => {
        ketcher.setMolecule(res.data.mol)
      }, 1000)
      this.postMessage('iupacChanged', {
        ...res.data,
        iupac: res.data.iupac || iupacText
      })
      this.dialog.exit()
    } else {
      alert('您输入的IUPAC Name无法转换成结构，请检查后重新确认~')
    }
  }
  render() {
    const { iupacText, ...prop } = this.props
    return (
      <Dialog
        title="IUPAC Name"
        ref={el => {
          this.dialog = el
        }}
        className="iupac"
        params={prop}
        buttons={[
          <button
            className="open-button iupac-from-ocsr-button"
            onClick={this.onOCRClick}>
            Load From OCR…
          </button>,
          'Cancel',
          <button disabled={iupacText.length === 0} onClick={this.onOkClick}>
            OK
          </button>
        ]}>
        <textarea
          value={iupacText}
          placeholder="IUPAC Name"
          style={{ whiteSpace: 'initial' }}
          onInput={e => {
            prop.updateBaseInfo({
              iupacText: e.target.value
            })
          }}
        />
      </Dialog>
    )
  }
}

export default connect(
  store => ({ ...store.toolbar }),
  dispatch => ({
    updateBaseInfo: newState => dispatch(updateBaseInfo(newState)),
    ...dispatch(initClipboard)
  })
)(IupacDialog)
